module.exports = __webpack_public_path__ + "static/media/startButtonHover.3757d0af.svg";